import * as React from 'react';

import * as styles from './OffersReliableBlockLayout.css';

export function OffersReliableBlockLayout({ children }: React.PropsWithChildren<{}>) {
  return <div className={styles['layout']}>{children}</div>;
}
